export enum CommonActionEnum {
    ACCEPT = 1,
    DENY = 2
}